<template>
  <v-container class="ma-0 pa-0">
    <v-card-text class="headline">
      Account #
      <code>{{
        user.is_copy_to ? user.client_id : selectedClient.id || "Loading..."
      }}</code>
    </v-card-text>
    <v-card-text class="body-1 pb-2" style="padding-left: 0;">
      Please include your account number on all sample submissions and
      correspondence.
    </v-card-text>
    <v-row>
      <v-col cols="12" class="pb-0">
        Business Name:
        {{
          user.is_copy_to
            ? user?.copy_to?.business_name
            : selectedClient.title || "N/A"
        }}
      </v-col>
      <v-col cols="12" class="pb-0">
        First Name:
        {{
          user.is_copy_to
            ? user?.copy_to?.first_name
            : selectedClient.first_name || "N/A"
        }}
      </v-col>
      <v-col cols="12" class="pb-2">
        Last Name:
        {{
          user.is_copy_to
            ? user?.copy_to?.last_name
            : selectedClient.last_name || "N/A"
        }}
      </v-col>
      <v-col cols="12" class="pb-0" v-if="user.is_copy_to">
        Username:
        {{ user?.username }}
      </v-col>
      <v-col cols="12" class="pb-0" v-if="user.is_copy_to">
        Email:
        {{ user?.copy_to?.email }}
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { mapState } from "vuex/dist/vuex.common.js";

export default {
  name: "AccountIdCardContent",
  computed: {
    ...mapGetters("clients", ["selectedClient"]),
    ...mapState("auth", ["user"])
  }
};
</script>

<style scoped></style>
